import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "@/lib/content";
import { useLanguage } from "@/context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SiteContentContext = createContext({ t: (k) => DEFAULT_CONTENT[k], refresh: () => {} });

export const SiteContentProvider = ({ children }) => {
  const { lang } = useLanguage();
  const [values, setValues] = useState(DEFAULT_CONTENT);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/site-content`, { params: { lang } });
      setValues({ ...DEFAULT_CONTENT, ...(data.values || {}) });
    } catch (e) {
      // keep defaults on failure
    }
  }, [lang]);

  useEffect(() => { refresh(); }, [refresh]);

  const t = useCallback((key) => {
    const v = values[key];
    return v !== undefined && v !== "" ? v : DEFAULT_CONTENT[key];
  }, [values]);

  return (
    <SiteContentContext.Provider value={{ t, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
